import React from 'react';

import { SVGComponentProps } from './svg.types';

const EmailSVG = ({ size = '1em', ...otherProps }: Omit<SVGComponentProps, 'wrapperClass'>) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.01031 9.70944C5 10.0827 5 10.5094 5 11V13C5 14.8856 5 15.8284 5.58579 16.4142C6.17157 17 7.11438 17 9 17H15C16.8856 17 17.8284 17 18.4142 16.4142C19 15.8284 19 14.8856 19 13V11C19 10.5094 19 10.0827 18.9897 9.70944L12.6817 12.9278C12.2535 13.1463 11.7465 13.1463 11.3183 12.9278L5.01031 9.70944ZM5.09655 8.65214C5.14096 8.6609 5.18492 8.67588 5.22724 8.69748L11.7728 12.037C11.9155 12.1099 12.0845 12.1099 12.2272 12.037L18.7728 8.69748C18.8151 8.67589 18.859 8.6609 18.9034 8.65214C18.8239 8.18785 18.6788 7.85039 18.4142 7.58579C17.8284 7 16.8856 7 15 7H9C7.11438 7 6.17157 7 5.58579 7.58579C5.32118 7.85039 5.1761 8.18785 5.09655 8.65214Z"
        fill="#BCBEC2"
      />
      <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" stroke="#D5D7DD" />
    </svg>
  );
};

export default EmailSVG;
